var map = {
	"./about.svg": "1687",
	"./add.svg": "76a4",
	"./align-text-justify.svg": "20d3",
	"./bell.svg": "3d56",
	"./calendar.svg": "b8bd",
	"./del.svg": "4b41",
	"./drag.svg": "88c6",
	"./edit.svg": "daf0",
	"./empty.svg": "8b70",
	"./more.svg": "0f4c",
	"./plus-circle.svg": "d99e",
	"./project.svg": "2df1",
	"./statistics.svg": "8ccb",
	"./tick.svg": "812c",
	"./todo.svg": "4694"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";